export default {
    methods: {
        switchItem (item) {
            if (this.activeItem === item) {
                this.activeItem = !this.activeItem
            } else {
                this.activeItem = item
            }
        }
    }
}
